
define("json!config.json", function(){ return {
    "host": "core.rusff.ru",
    "transport":
    {
        "userPort": "/",
        "rpcPort":  "/rusff.php",
        "channels":
        {
            "collector": "start/index",
            "board": "board",
            "getBalance": "board/getBalance",
            "foundation": "foundation/getPayInLogs",
            "getAwards": "awards/index",
            "deleteAward": "awards/delete",
            "sendAward": "awards/send",
            "editSentAward": "awards/edit",
            "awardItem": "awards/item",
            "awardRemoveItem": "awards/remove",
            "getDesc": "board/getDesc",
            "editDesc": "board/setDesc",
            "getAdminNotes": "board/getNote",
            "setAdminNotes": "board/setNote",
            "sendReport": "reports/send",
            "getReports": "reports/index",
            "markReportAsRead": "reports/markRead",
            "admin": "admin/start",
            "sendReputation": "reputation/add",
            "getReputation": "reputation/index",
            "removeReputation": "reputation/delete"
        },
        "io": {
            "enabled": true,
            "host": "qnode.qsdb.ru",
            "port": 443,
            "appChannel": "/app",
            "channels": {
                "init": "init"
            }
        }
    },
    "modules": {
        "collector": {
            "enabled": true
        },
        "foundation": {
            "enabled": true,
            "type": "points"
        },
        "awards": {
            "enabled": true,
            "menuLink": true,
            "moderatorsAccess": false

        },
        "boardDescription": {
            "enabled": true
        },
        "textareaResizer": {
            "enabled": true
        },
        "notes": {
            "enabled": true
        },
        "reports": {
            "enabled": true,
            "buttonText": "Пожаловаться"
        },
        "twitter": {
            "enabled": true,
            "count": 5
        },
        "reputation": {
            "enabled": true
        },
        "notifications": {
            "enabled": true
        }
    },
    "sounds": [
        "_message"
    ]
}
;});

